import { ClientInferRequest, ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";
import { ApiError, extractDomainError } from "#shared/infra/apiError";

export type CreateDefaultProcessStep = ClientInferResponseBody<
  typeof contract.defaultProcessSteps.create,
  200
>;

export type CreateDefaultProcessStepDto = ClientInferRequest<
  typeof contract.defaultProcessSteps.create
>["body"];

export const createDefaultProcessStep = async ({
  payload,
}: {
  payload: CreateDefaultProcessStepDto;
}): Promise<CreateDefaultProcessStep> => {
  const response = await api.defaultProcessSteps.create.mutation({
    body: payload,
  });

  if (response.status === 200) {
    return response.body;
  }

  const domainError = extractDomainError(response.body);
  if (domainError) {
    throw domainError;
  }

  if (response.status === 400) {
    throw new ApiError(
      `Erreur lors de l'ajout du procédé par défaut: ${response.body.message}`,
      response.status,
      response.body,
    );
  }

  throw new ApiError(
    "Erreur lors de l'ajout du procédé par défaut",
    response.status,
    response.body,
  );
};
